// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2hSgd","item":"PaymentsMobile_item__1m-_F","label":"PaymentsMobile_label__3r0B3","amount":"PaymentsMobile_amount__5zL4F"};